import React from "react";
import { Box, Flex, Image } from "@chakra-ui/react";
import { Viewer } from "../../components/Viewer";
import { useQViewer } from "./useQViewer";
import { Timer } from "../../components/Timer";
import { QuestionProgress } from "../../components/QuestionProgress";
import { StopwatchIcon } from "../../components/Icons/StopwatchIcon";
import { LearnFeedback } from "../../components/LearnFeedback";
import { AIChat } from "../../components/AIChat";

export const QViewerPage = ({ user, loadingCallback, loading }) => {
  const {
    selectedDyno,
    effectiveUserId,
    qSetId,
    requestStores,
    lastAttemptedDynoId,
    submissionCallback,
    dynoLoading,
    currentQSetDynoIndex,
    isLastDynoOfQSet,
    dynoIdList,
    isLearnMode,
    isRevealed,
    learnResult,
    goToNextLearnQuestion,
    askAI,
    chatLoading,
    toggleChat,
    toggleAIChat,
    followUpQuestions,
    chat,
    askFollowUPQuestion,
    askFirstQuestion,
    onReview,
    regenerate,
    openModal,
    closeModal,
    feedback,
    setFeedback,
    submitFeedback,
    feedbackResponse,
    hasReachedMaxLimit,
  } = useQViewer({ user, loadingCallback });
  const userInfo = { ...user, id: effectiveUserId };
  const showLearnFeedback = isLearnMode && isRevealed;
  return (
    <Box>
      <Flex justifyContent="space-between" width="100%" background={isLearnMode ? "#f7fafb" : "#fff"}>
        {dynoLoading && (
          <Box className="overlay-loader">
            <Image src="/images/ninja.gif" width="100px" height= "100px"/>
          </Box>
        )}
        <Flex width="100%" minWidth={0} className={`quiz-page${showLearnFeedback ? " learn-revealed" : ""}`} alignItems={"flex-start"} backgroundColor= "#f7fafb">
          {!dynoLoading && (
            <Box
              className={
                selectedDyno.myDyno &&
                selectedDyno.myDyno.info.dyno_type === "Practice"
                  ? "practice-dyno"
                  : "common-dyno"
              }
            >
              {showLearnFeedback && (
                <LearnFeedback
                  result={learnResult}
                  isLastQuestion={currentQSetDynoIndex === dynoIdList.length}
                  onNext={goToNextLearnQuestion}
                />
              )}
              {selectedDyno?.myDyno?._id && (
                <Viewer
                  selectedDyno={selectedDyno}
                  requestStores={requestStores}
                  userInfo={userInfo}
                  submissionCallback={submissionCallback}
                  lastAttemptedDynoId={lastAttemptedDynoId}
                  qSetId={qSetId}
                  isLastDynoOfQSet={isLastDynoOfQSet}
                />
              )}
            </Box>
          )}
          <Box className="timer-chat-box">
            <Box className="timer-chat-wrap">
              {!loading && !dynoLoading &&
                <>
                  <Box className="info-container align-start">
                    <Box className="info-wrapper padding-10">
                    <QuestionProgress current={currentQSetDynoIndex} total={dynoIdList.length} />
                    {/* Learn mode is about understanding, not speed, so no clock. */}
                    {!isLearnMode && (
                      <Box className="time-stat time-elapsed">
                        <StopwatchIcon className="time-stat__icon" />
                        <span className="time-stat__label">Time elapsed</span>
                        <Timer />
                      </Box>
                    )}
                    </Box>
                  </Box>
                </>
              }
            </Box>
          </Box>
        </Flex>
        {isLearnMode && (
          <AIChat
            askAI={askAI}
            chatLoading={chatLoading}
            chat={chat}
            toggleChat={toggleChat}
            toggleAIChat={toggleAIChat}
            followUpQuestions={followUpQuestions}
            askFollowUPQuestion={askFollowUPQuestion}
            onReview={onReview}
            openModal={openModal}
            closeModal={closeModal}
            regenerate={regenerate}
            feedback={feedback}
            setFeedback={setFeedback}
            submitFeedback={submitFeedback}
            feedbackResponse={feedbackResponse}
            askFirstQuestion={askFirstQuestion}
            hasReachedMaxLimit={hasReachedMaxLimit}
            isLocked={!isRevealed}
          />
        )}
      </Flex>
    </Box>
  );
};
